/**
 * HR Portal Color Scheme
 * Purple and Gold Theme
 */

export const colors = {
  // Main brand colors
  header: '#532E79',           // Purple
  headerAccent: '#B98330',     // Gold

  // Purple shades (light to dark)
  business: '#6B4490',         // Lighter purple
  application: '#8B6BB1',      // Light purple
  data: '#A590C5',             // Lighter purple
  technology: '#C5B3D8',       // Very light purple
  shared: '#9B7EBD',           // Medium purple
  integration: '#8B5FA8',      // Medium purple

  // Gold shades
  customer360: '#B98330',      // Gold
  financial: '#D4A556',        // Light gold

  // Neutrals
  text: '#2c2c2c',
  white: '#ffffff',
  lightBg: '#f8f6fa',
  accent: '#E8DCEF',

  // Status colors (for consistency)
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
} as const;

export type ColorKey = keyof typeof colors;
